import cloneDeep from 'lodash/cloneDeep';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';
import { getEvidenceByLinkServiceResponse } from 'redpoints-front-common/services';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_EVIDENCES,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK_ERROR,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK_FAILURE,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK_SUCCESS,
} from '../../../../actions/actionTypes';

export const additionalActionsReducer = (state, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_SAVE_DETECTION_LINK_ERROR:
    case INCIDENT_DETAILS_SAVE_DETECTION_LINK_FAILURE:
    case INCIDENT_DETAILS_SAVE_DETECTION_LINK_SUCCESS: {
      const newState = cloneDeep(state);
      newState.data = getEvidenceByLinkServiceResponse(state.data, action);
      return newState;
    }
    default:
      return state;
  }
};

const detectionLinkEvidencesOriginal = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_EVIDENCES,
  additionalActionsReducer
);

export default detectionLinkEvidencesOriginal;
